import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import PersonalDetailsForm from "~/Components/Forms/PersonalDetailsForm/PersonalDetailsForm";
import { adminHttp } from "~/Admin/services/http";
import { EditIcon } from '../../../Components/Icons/Icons';
import { connect } from "react-redux";
import { guestPersonalDetails } from '../../../services/adapters/guest';
import ValidationError from '../../../Components/Forms/ValidationError';
import TextTranslate from "~/Components/TextTranslate/TextTranslate";
import { toast } from 'react-toastify';

const AdminEditPersonalDetails = ({ guest, event, onChange, dispatch, icon = false, ...rest }) => {
    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const currentFormData = guestPersonalDetails(guest);

    const [form, setForm] = useState({
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        company: '',
        job_title: '',
        guest_group: '',
    });

    const locales = {
        local: "Local",
        international: "International",
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        toast.promise(
            adminHttp.put(`/events/${event.id}/guests/${guest.id}/update`, form),
            {
                pending: 'Saving Personal details...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'Personal details saved'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    useEffect(() => {
        let guestGroup = guest?.guest_group || 0;
        setForm({ ...form, ...currentFormData, guest_group: guestGroup });
    }, [guest]);

    return (
        <>
            {
                icon
                    ? <span {...rest} onClick={handleShow}><EditIcon /></span>
                    : <button {...rest} onClick={handleShow}>Edit Personal Details</button>
            }

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Personal Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PersonalDetailsForm values={form} errors={error?.errors} onChange={setForm} />

                    <div className="form-row form-row-fluid">
                        <div className="form-group guest-group col-md-12 pr-sm-1 pr-lg-2">
                            <label><TextTranslate name="guest-group" fallback="Guest Group" /></label>
                            <select
                                name="guest_group"
                                defaultValue={guest?.guest_group || 0}
                                onChange={(e) => setForm({ ...form, guest_group: e.target.value })}
                                className="form-control"
                            >
                                <option value={undefined} />
                                {Object.keys(locales).map((key, idx) => {
                                    return <option key={`guestgroup_${idx}`} value={key}>{locales[key]}</option>
                                })}
                            </select>
                            <ValidationError errors={error} name="guest_group" />
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditPersonalDetails);
